@if (auth.isMaster() && !auth.getCustomerAlias()) {
  <div class="searchbar-container">
    <button
      mat-fab
      color="primary"
      class="global-search-button"
      (click)="onShowGlobalSearch()"
      [matTooltip]="'Globale Suche öffnen'">
      <fa-icon
        [icon]="['far', 'globe']"
        size="2x"
        class="search-button-icon"></fa-icon>
    </button>

    @if (showGlobalSearch()) {
      <mat-card appearance="outlined" class="global-search-card">
        <div class="search-card-header">
          <span class="search-card-title">Globale Suche</span>
          <button
            mat-icon-button
            class="close-button"
            (click)="showGlobalSearch.set(false)">
            <fa-icon [icon]="['far', 'times']"></fa-icon>
          </button>
        </div>

        <div [formGroup]="globalSearchForm" class="search-card-body">
          <mat-form-field appearance="fill" class="search-form-field">
            <mat-label>Station suchen</mat-label>
            <input
              matInput
              placeholder="Stationsnamen eintippen (mind. 4 Zeichen)"
              [matAutocomplete]="stationAutocomplete"
              formControlName="stationInput" />
          </mat-form-field>

          <mat-autocomplete #stationAutocomplete="matAutocomplete">
            @if (isStationLoading()) {
              <mat-option disabled class="autocomplete-loading-state">
                <mat-spinner diameter="24"></mat-spinner>
              </mat-option>
            }

            @if (noResults() && !isStationLoading()) {
              <mat-option disabled class="autocomplete-empty-state">
                No stations found
              </mat-option>
            }

            @for (station of filteredStations$ | async; track station.id) {
              <mat-option
                [value]="station"
                (onSelectionChange)="onStationChange($event, station)">
                {{ displayStation(station) }}
              </mat-option>
            }
          </mat-autocomplete>
        </div>
      </mat-card>
    }
  </div>
}
